import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, Button, Input } from 'reactstrap';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import MyLoader from './util/loader';
import MyStorage from './util/storage';
import Api from './api/api';
import showToast from './util/toast';
import { ToastContainer } from 'react-toastify';
import { ContentState, convertFromHTML } from 'draft-js';


const Settings = () => {
    const history = useHistory()
    const location = useLocation()
    let filePath = MyStorage.getFileUrls().LibraryImages;

    const [mainShot, setMainShot] = useState(null);
    const [mainShotUrl, setMainShotUrl] = useState(null);
    const [mainShotName, setMainShotName] = useState(null);
    const addMainShot = useRef(null);

    const [emailBanner, setEmailBanner] = useState(null);
    const [emailBannerUrl, setEmailBannerUrl] = useState(null);
    const addEmailBanner = useRef(null);

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [loader, setLoader] = useState(false);
    const [goals, setGoals] = useState([])
    const [newGoal, setNewGoal] = useState('')
    const [status, setStatus] = useState([])
    const [newStatus, setNewStatus] = useState('')

    const [main_library, setMainLibrary] = useState('')
    const [sp_library, setSpLibrary] = useState('')

    useEffect(() => {
        loadSettings()
        loadMainLibraryImage()
        loadScreenMessages()
        loadGoals()
    }, [])

    const loadMainLibraryImage = () => {
        setLoader(true)
        Api.getMainLibraryImage(
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                setMainShotUrl(response.data)
            },
            (error) => {
                setLoader(false)
            });
    };

    const loadSettings = () => {
        setLoader(true)
        Api.getSettings(
            (response) => {
                setLoader(false)
                console.log('SETTINGS: ' + JSON.stringify(response));
                let settings = response.data
                let welcome_email = ''
                let email_banner = ''
                for (let i = 0; i < settings.length; i++) {
                    if (settings[i].type === 'welcome_email') {
                        welcome_email = settings[i].text
                    }
                    if (settings[i].type === 'email_banner') {
                        email_banner = settings[i].text
                    }
                }
                console.log('welcome_email: ' + welcome_email);
                console.log('email_banner: ' + email_banner);
                setEmailBannerUrl(email_banner)
                setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(welcome_email))))
            },
            (error) => {
                setLoader(false)
            });
    };

    const loadScreenMessages = () => {
        setLoader(true)
        Api.getScreenMessages(
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                setMainLibrary(response.main_library)
                setSpLibrary(response.sp_library)
            },
            (error) => {
                setLoader(false)
            });
    };

    const loadGoals = () => {
        setLoader(true)
        Api.getFilters(
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                setGoals(response.goals)
                setStatus(response.status)
            },
            (error) => {
                setLoader(false)
            });
    };

    const onEditorStateChange = (editorState) => {
        console.log(JSON.stringify(editorState));
        setEditorState(editorState)
    };

    const saveMainLibraryImage = (file) => {
        setLoader(true)
        Api.saveMainLibraryImage(file,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                showToast('success', 'Image saved!')
            },
            (error) => {
                setLoader(false)
            });
    };

    const saveEmailBanner = (file) => {
        setLoader(true)
        Api.saveEmailBanner(file,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                showToast('success', 'Image saved!')
            },
            (error) => {
                setLoader(false)
            });
    };

    const saveChanges = () => {
        setLoader(true)
        let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))

        Api.saveWelcomeEmail(body,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
            },
            (error) => {
                setLoader(false)
            });

        Api.saveScreenMessages(main_library, sp_library,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                showToast('success', 'Changes Saved!')
            },
            (error) => {
                setLoader(false)
            });
    };

    const deleteGoal = (goal) => {
        setLoader(true)
        Api.deleteGoal(goal.id,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                showToast('success', 'Changes Saved!')
                const list = goals.filter((item, j) => {
                    return item.id + '' !== goal.id + ''; //false will delete
                });
                setGoals(list)
            },
            (error) => {
                setLoader(false)
            });
    };

    const addGoal = () => {
        if (newGoal === '')
            return
        setLoader(true)
        Api.addGoal(newGoal,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                showToast('success', 'Changes Saved!')
                const list = goals.concat(response.data);
                setGoals(list)
            },
            (error) => {
                setLoader(false)
            });
    };

    const deleteStatus = (status_) => {
        setLoader(true)
        Api.deleteStatus(status_.id,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                showToast('success', 'Changes Saved!')
                const list = status.filter((item, j) => {
                    return item.id + '' !== status_.id + ''; //false will delete
                });
                setStatus(list)
            },
            (error) => {
                setLoader(false)
            });
    };

    const addStatus = () => {
        if (newStatus === '')
            return
        setLoader(true)
        Api.addStatus(newStatus,
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                showToast('success', 'Changes Saved!')
                const list = status.concat(response.data);
                setStatus(list)
            },
            (error) => {
                setLoader(false)
            });
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Settings
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 15 }}>
                <Form className="form" style={{ width: 600, marginTop: 20, backgroundColor: '#f2f2f2' }}>

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>
                        Email Banner Image
                    </div>
                    <div style={{ marginRight: 0, marginBottom: 0 }}>
                        <div
                            onClick={() => {
                                addEmailBanner.current.click();
                            }}
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addEmailBanner}
                                onChange={(event) => {
                                    setEmailBanner(event.target.files[0]);
                                    setEmailBannerUrl(URL.createObjectURL(event.target.files[0]))
                                    saveEmailBanner(event.target.files[0])
                                }} />
                            <img src={emailBannerUrl} style={{ width: 225, height: 150, backgroundColor: 'gray', objectFit: 'cover' }} />
                            <div style={{ color: 'blue' }}>Click to change</div>
                        </div>
                    </div>

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>
                        Main Library Image
                    </div>
                    <div style={{ marginRight: 0, marginBottom: 0 }}>
                        <div
                            onClick={() => {
                                addMainShot.current.click();
                            }}
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addMainShot}
                                onChange={(event) => {
                                    setMainShot(event.target.files[0]);
                                    setMainShotUrl(URL.createObjectURL(event.target.files[0]))
                                    saveMainLibraryImage(event.target.files[0])
                                    // setTitle(event.target.files[0].name.split('.')[0])
                                }} />
                            <img src={mainShotUrl} style={{ width: 225, height: 150, backgroundColor: 'gray', objectFit: 'cover' }} />
                            <div style={{ color: 'blue' }}>Click to change</div>
                        </div>
                    </div>

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Welcome Email</div>
                    <Editor
                        editorStyle={{ backgroundColor: 'white', paddingLeft: 10, paddingRight: 10, height: 150 }}
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={onEditorStateChange}
                    />

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Main Library Screen Text</div>
                    <Input
                        style={{ marginTop: 0, height: 70, fontSize: 16 }}
                        type='textarea'
                        placeholder=''
                        value={main_library}
                        onChange={(event) => {
                            setMainLibrary(event.target.value)
                        }} />

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Special Library Screen Text</div>
                    <Input
                        style={{ marginTop: 0, height: 70, fontSize: 16 }}
                        type='textarea'
                        placeholder=''
                        value={sp_library}
                        onChange={(event) => {
                            setSpLibrary(event.target.value)
                        }} />

                    <Button
                        style={{ marginTop: 20, fontSize: 16 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            saveChanges()
                        }}>
                        Save Changes
                    </Button>
                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Goals</div>
                    {goals.map((item, index) => {
                        return (
                            <div style={{ display: 'flex', flex: 1, marginTop: 5 }}>
                                <div style={{ padding: 5, backgroundColor: 'white', borderRadius: 5, flex: 1 }}>
                                    {item.title}
                                </div>
                                <Button
                                    style={{ fontSize: 14, backgroundColor: 'red', borderWidth: 0, marginLeft: 10 }}
                                    className='btn-block btn-dark'
                                    onClick={() => {
                                        deleteGoal(item)
                                    }}>
                                    Delete
                                </Button>
                            </div>
                        )
                    })}
                    <Input
                        style={{ marginTop: 10, height: 40, fontSize: 16 }}
                        type='text'
                        placeholder='Enter New Goal'
                        value={newGoal}
                        onChange={(event) => {
                            setNewGoal(event.target.value)
                        }} />
                    <Button
                        style={{ marginTop: 10, fontSize: 16 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            addGoal()
                        }}>
                        Add New Goal
                    </Button>

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Status</div>
                    {status.map((item, index) => {
                        return (
                            <div style={{ display: 'flex', flex: 1, marginTop: 5 }}>
                                <div style={{ padding: 5, backgroundColor: 'white', borderRadius: 5, flex: 1 }}>
                                    {item.title}
                                </div>
                                <Button
                                    style={{ fontSize: 14, backgroundColor: 'red', borderWidth: 0, marginLeft: 10 }}
                                    className='btn-block btn-dark'
                                    onClick={() => {
                                        deleteStatus(item)
                                    }}>
                                    Delete
                                </Button>
                            </div>
                        )
                    })}
                    <Input
                        style={{ marginTop: 10, height: 40, fontSize: 16 }}
                        type='text'
                        placeholder='Enter New Status'
                        value={newStatus}
                        onChange={(event) => {
                            setNewStatus(event.target.value)
                        }} />
                    <Button
                        style={{ marginTop: 10, fontSize: 16 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            addStatus()
                        }}>
                        Add New Status
                    </Button>

                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default Settings;